import { POneEvent } from '@modules/auth/hooks/types'
import { CircularProgress } from '@mui/material'
import { useQuery } from '@tanstack/react-query'

import searchApi from '../../search/api'
import DelegateCard from './DelegateCard'
import { LoaderContainer, SectionContent, SectionTitle, SectionWrapper } from './index.styles'

interface DelegatesSectionProps {
  event: POneEvent
  companyId?: number
  showContactBtn: boolean
}

const DelegatesSection = ({ event, companyId, showContactBtn }: DelegatesSectionProps) => {
  const { data, isLoading } = useQuery({
    queryKey: [searchApi.getCompanyDelegates.key, companyId, event.id],
    queryFn: () => searchApi.getCompanyDelegates.fn({ companyId, eventId: event.id }),

    enabled: !!companyId,
  })

  return (
    <SectionWrapper>
      <SectionTitle>{event.name}</SectionTitle>
      {!isLoading ? (
        <SectionContent>
          {data?.delegates.map(delegateItem => (
            <DelegateCard key={delegateItem.id} delegate={delegateItem} companyId={companyId} showContactBtn={showContactBtn} />
          ))}
        </SectionContent>
      ) : (
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      )}
    </SectionWrapper>
  )
}

export default DelegatesSection
